import { Route, Routes } from 'react-router';
import { useTranslation } from 'react-i18next';
import { SemPermissao, Vazio } from '../../componentes/estados';
import { useSessao } from '../../nucleo/sessao';
import { CamposCrm, EditorModeloProposta, FontesCampanhas, FunisCrm, ModelosPropostaCrm, MotivosPerdaCrm, QualificacaoCrm, QuestionariosCrm } from './ConfiguracoesCrm';
import { IndiceConfiguracoes, ModelosEmailCrm, PreferenciasCrm } from './ConfiguracoesCrm2';
import { StatusPropostaCrm } from './StatusPropostaCrm';
import { CentralArquivosCrm } from './CentralArquivos';
import { Workflows } from './Workflows';
import { ProdutosServicosCrm } from './ProdutosServicosCrm';

/**
 * CRM no novo desenho: Configurações do CRM (como a área de configurações do clone do RD). Só quem configura o CRM
 * (`pipeline.configurar`, val5).
 * Ajustes do CRM (27/10, K21): a página inicial (sugestões, busca e grade de grupos, como o RD).
 * Lote crm7 (ficha 2026-10-29 "configuracoes-do-crm-igual-a-origem"): como na origem, sem o menu lateral de seções. O índice
 * é o ponto de partida e cada seção abre em página inteira, com o cabeçalho próprio (seta de voltar ao índice, título, botão
 * primário e abas). Os caminhos das seções ficam os mesmos; entram as abas (`fontes/campanhas`, `campos/empresa`,
 * `campos/contato`, `campos/produto`) e o editor do modelo de proposta em página (`modelos/:id`, `modelos/novo`).
 */
export function PaginaConfiguracoes() {
  const { t } = useTranslation('pipeline');
  const { t: tn } = useTranslation();
  const s = useSessao();
  // Val5 (29/10): configurar o CRM tem ação própria (`pipeline.configurar`).
  if (!s.pode('pipeline.configurar')) return <SemPermissao />;
  return (
    <div className="flex min-w-0 flex-col gap-5" data-configuracoes-crm="">
      <Routes>
        <Route
          index
          element={
            <>
              <header>
                <p className="kicker">{t('casca.comercial')}</p>
                <h1 className="mt-1 text-2xl font-bold tracking-tight">{t('crm.configuracoes.titulo')}</h1>
              </header>
              <IndiceConfiguracoes />
            </>
          }
        />
        <Route path="funis" element={<FunisCrm />} />
        <Route path="campos" element={<CamposCrm />} />
        <Route path="campos/empresa" element={<CamposCrm aba="empresa" />} />
        <Route path="campos/contato" element={<CamposCrm aba="contato" />} />
        {/* Lista de 03/11, item 7: o caminho antigo `campos/produto` segue levando à aba, agora a de Produtos e Serviços. */}
        <Route path="campos/produto" element={<CamposCrm aba="produto" />} />
        {/* Lista de 03/11, item 9: o catálogo de venda com o mesmo formulário do "Criar novo produto/serviço". */}
        <Route path="produtos" element={<ProdutosServicosCrm />} />
        <Route path="motivos" element={<MotivosPerdaCrm />} />
        <Route path="fontes" element={<FontesCampanhas tipo="fontes" />} />
        <Route path="fontes/campanhas" element={<FontesCampanhas key="campanhas" tipo="campanhas" />} />
        <Route path="qualificacao" element={<QualificacaoCrm />} />
        <Route path="questionarios" element={<QuestionariosCrm />} />
        <Route path="modelos" element={<ModelosPropostaCrm />} />
        <Route path="modelos/:id" element={<EditorModeloProposta />} />
        <Route path="status-proposta" element={<StatusPropostaCrm />} />
        <Route path="modelos-email" element={<ModelosEmailCrm />} />
        <Route path="workflows" element={<Workflows />} />
        <Route path="preferencias" element={<PreferenciasCrm />} />
        {/* Lote crm8 (item 3): Preferências > Central de Arquivos, como na origem. */}
        <Route path="preferencias/arquivos" element={<CentralArquivosCrm />} />
        <Route path="*" element={<Vazio titulo={tn('estados.naoEncontrado')} texto="" />} />
      </Routes>
    </div>
  );
}
